<ng-container
  *ngTemplateOutlet="
    submenuDirection === 'left' && submenuDirectionTemplate;
    context: { disabled: isDisabled }
  "
></ng-container>

@if (menuAction) {
  <div
    class="w-full flex items-center gap-2"
    [ngbTooltip]="shouldDisplayTooltipIfExists && menuAction.tooltipByCondition ? menuAction.tooltipByCondition(context) : undefined"
    [tooltipClass]="'dropdown-option-tooltip default-tooltip'"
    [keepOnHover]="menuAction.keepTooltipOnHover"
    [placement]="'auto'">
    @if (icon) {
      <svg-icon
        class="option-icon {{ menuAction.iconClasses }} {{ menuAction.iconColorMode }}"
        [src]="icon"
      ></svg-icon>
    }

    @if (translationKey && secondaryTranslationKey) {
      <div class="flex flex-col">
        <span
          class="font-main font-bold text-navy-90"
          [innerHTML]="translationKey | translate: (itemTranslationParam | async)"
        ></span>

        <span
          class="font-main text-navy-70"
          [innerHTML]="secondaryTranslationKey | translate: (itemSecondaryTranslationParam$ | async)"
        ></span>
      </div>
    } @else if (translationKey) {
      <span
        class="truncate capitalize-first-letter"
        [innerHTML]="translationKey | translate: (itemTranslationParam | async)"
        [ngbTooltip]="translationKey | translate: (itemTranslationParam | async)"
        [openTooltipWhenOverflowedAndHovered]="true"
        [openOnWidthOverflow]="true"
        [placement]="'top'"
      ></span>
    } @else {
      <span
        class="truncate capitalize-first-letter"
        [ngbTooltip]="menuAction.value"
        [openTooltipWhenOverflowedAndHovered]="true"
        [openOnWidthOverflow]="true"
        [placement]="'top'"
      >
        {{ menuAction.value }}
      </span>
    }
  </div>
} @else {
  <ng-content></ng-content>
}

@if (isComingSoon) {
  <svg-icon data-test-id="coming-soon-mark" [src]="'coming-soon'"></svg-icon>
}

<ng-container *ngTemplateOutlet="submenuDirection === 'right' && submenuDirectionTemplate"></ng-container>

<ng-template #submenuDirectionTemplate let-disabled="disabled">
  @if (menuAction.subMenuIcon) {
    <svg-icon
      class="sub-menu-icon {{ menuAction.iconClasses }} {{ menuAction.iconColorMode }}"
      [src]="menuAction.subMenuIcon"
    ></svg-icon>
  } @else {
    <span class="w-5 h-5 flex items-center" [attr.data-test-id]="'arrow-' + submenuDirection">
      <svg-icon
        class="arrow-icon relative transform h-2 w-4"
        [ngClass]="{
          '-rotate-90': submenuDirection === 'left',
          'rotate-90 -right-1 justify-self-end': submenuDirection === 'right',
          'opacity-50': isDisabled
        }"
        [src]="'arrow-single'"
      ></svg-icon>
    </span>
  }
</ng-template>
